import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { signUp } from '../store/auth/actions'

import SignUpForm from '../components/form/SignUpForm'
import AppLink from '../components/shared/AppLink'

import {
  container,
  linkContainer
} from './styles/LoginPage.style'

const LoginPage = ({ signUp, ...props }) => {
  const { t } = useTranslation()
  return (
    <div className={container}>
      <SignUpForm {...props} translation={t} onSubmit={({ passwordConfirmation, ...rest }) => signUp({ data: rest, translation: t })} />

      <div className={linkContainer}>
        <AppLink to={'/login'}>{t('register')['loginLink']}</AppLink>
      </div>
    </div>
  )
}
LoginPage.propTypes = {
  signUp: PropTypes.func.isRequired
}

LoginPage.defaultProps = {
  loginValues: undefined
}

const mapStateToProps = (state) => ({
  lang: state.auth.lang
})

const mapDispatchToPros = dispatch =>
  bindActionCreators(
    {
      signUp
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToPros)(LoginPage)
